import { m } from '../paraglide/messages';
import { cn } from '../lib/utils';
import { ENDONYM, SHORT_ENDONYM } from './endonym';
import { useLanguageLinks } from './useLanguageLinks';

/**
 * The last row of the header's mobile menu: this page's languages as short
 * links in a grid of four columns, so eight fit a phone's width on two lines,
 * the current one in full ink. Nothing on an untranslated page.
 */
export const HeaderLanguageRow = () => {
  const links = useLanguageLinks();
  if (links === null) return null;
  return (
    <div className="flex flex-col gap-2 border-t border-rule py-3 text-15">
      <span className="font-medium text-text-2">{m.language_switcher_label()}</span>
      <nav aria-label={m.language_switcher_label()} className="grid grid-cols-4 gap-1.5">
        {links.map(({ locale, href, current }) => (
          <a
            key={locale}
            href={href}
            hrefLang={locale}
            lang={locale}
            title={ENDONYM[locale]}
            aria-label={ENDONYM[locale]}
            aria-current={current ? 'page' : undefined}
            className={cn(
              'rounded-8 border py-1.5 text-center',
              current ? 'border-rule bg-rail-2 font-medium text-text' : 'border-transparent text-text-2 hover:text-text',
            )}
          >
            {SHORT_ENDONYM[locale]}
          </a>
        ))}
      </nav>
    </div>
  );
};
